import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { XIcon } from '@phosphor-icons/react/dist/ssr/X'
import { ScrollArea } from '@skop-app/lib-front'
import { cx } from 'class-variance-authority'

type DrawerProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode
  title?: string
  className?: string
  mask?: boolean
  panelSize?: 'default' | 'wide'
  respectAppHeader?: boolean
  suspended?: boolean
}

export const Drawer = ({
  open,
  setOpen,
  title,
  children,
  className,
  mask,
  panelSize = 'default',
  respectAppHeader = false,
  suspended = false,
}: DrawerProps) => (
  <Dialog
    open={open && !suspended}
    onClose={setOpen}
    unmount={false}
    className="relative z-10"
  >
    <div
      className={cx(
        'fixed bottom-0 right-0',
        respectAppHeader ? 'top-[var(--app-drawer-top)]' : 'top-0',
        mask && 'left-0',
      )}
    />
    <div
      className={cx(
        'fixed bottom-0 right-0 overflow-hidden',
        respectAppHeader ? 'top-[var(--app-drawer-top)]' : 'top-0',
        mask && 'left-0',
      )}
    >
      <div
        className={cx(
          'absolute bottom-0 right-0 overflow-hidden',
          respectAppHeader ? 'top-[var(--app-drawer-top)]' : 'top-0',
          mask && 'left-0',
        )}
      >
        <div
          className={cx(
            'pointer-events-none fixed bottom-0 right-0 flex max-w-full pl-8',
            respectAppHeader ? 'top-[var(--app-drawer-top)]' : 'top-0',
          )}
        >
          <DialogPanel
            transition
            className={cx(
              'pointer-events-auto w-screen transform transition duration-300 ease-in-out data-[closed]:translate-x-full',
              className,
              !className &&
                (panelSize === 'wide'
                  ? 'max-w-2xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-6xl'
                  : 'max-w-sm xl:max-w-lg'),
            )}
          >
            <div className="flex h-full flex-col gap-3 bg-white py-3 shadow-xl">
              <div className="px-3 lg:px-6">
                <div className="flex items-center justify-between gap-3">
                  <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                    {title}
                  </DialogTitle>
                  <div className="flex h-7 items-center">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                    >
                      <span className="absolute -inset-2.5" />
                      <span className="sr-only">Close panel</span>
                      <XIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="relative h-full flex-1 !pl-6 !pr-3 lg:px-8">
                <ScrollArea className="h-full !pr-3 pb-12" scrollBarCn="pb-12">
                  {children as any}
                </ScrollArea>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>
)
